module.exports = __webpack_public_path__ + "static/media/20200510-kin-au-cv-website.e6ccea6f.pdf";